import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const subscribe = async (email, source, productTitle) => {
  const { data } = await axios.post(`${API}/api/subscribe`, {
    email,
    source,
    product_title: productTitle || null,
  });
  return data;
};

export const sendContact = async (form) => {
  const { data } = await axios.post(`${API}/api/contact`, form);
  return data;
};
